import {ColumnMain} from "../column-main";
import {Column} from "../column";
import {Trans} from "@lingui/macro";
import React from "react";

const UsersListModel = () : ColumnMain => {

    const columns : Array<Column> = new Array();
    columns.push({key:'loginName', filter:true, sorter:true,title:<Trans>Login Name</Trans>});
    columns.push({key:'email', filter:true, sorter:true,title:<Trans>Email</Trans>});
    columns.push({key:'roles', filter:true, sorter:true,title:<Trans>Role</Trans>,
        render: (value) => Array.isArray(value) && value.length > 0 ? value[0]['roleName'] : ""
    });
    columns.push({key:'updatedDate', width: 150, dateTimeFilter:true, sorter:true,title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 150, sorter:true,title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 150, dateTimeFilter:true, sorter:true,title:<Trans>Created Date</Trans>,direction:"desc"});
    columns.push({key:'createdBy', width: 150, sorter:true,title:<Trans>Created By</Trans>});

    return{
        columns:columns,
        url:"/resource/user"
    };

}
export default UsersListModel();
